import { Products } from 'common/src/types/enums/Products.enum';

import useAuth from 'portal/src/auth/useAuth';

// Alerts are hidden entirely on the Interval Data deployment.
export function useHasAlertsFeature(): boolean {
  const { featureChecker } = useAuth();

  if (import.meta.env.VITE_PRODUCT_ID === Products.intervals) {
    return false;
  }

  return featureChecker.alertsEnabled();
}
